import superagent from 'superagent'

import config from '../../config'
import auth from '../../auth'

export default {
    create,
}

async function create(opt) {
    const res = await superagent
        .post(config.url_api + '/account')
        .type('form')
        .query(auth.getAuthQs())
        .send({
            username: opt.username,
            password: opt.password,
            quota: opt.quota,
            region: opt.region,
            sticky: opt.sticky,
        })
    if (res.status != 201) {
        throw new Error('There was an unknown error. Please try again later')
    }
    return true
}